/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import EditorSaver from '../fw/EditorSaver';

import {wrapNotFound} from '../app/NotFoundHandler.react';
import * as Tool from '../fw/Tool';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import * as Permission from './../../common/util/Permission';
import * as BrowserPermission from '../BrowserPermission';
import urlMapping from "../app/URLMapping";

const messages = defineMessages({
    title: {id: 'flowAddStep1.addTitle', 'defaultMessage': 'Adding new Flow'}
});

export function createFlowFromFlowDef(flowDef, organisation, activate : boolean = false) {
    let fatQuery = Relay.QL `fragment on CreateFlowPayload @relay(pattern: true) {
                                    edge {
                                        node {
                                            id,
                                            realId,
                                            organisation_id,
                                            flowDef {
                                                id,
                                                realId,
                                            }
                                        }
                                    },
                                    organisation {
                                        flows(first: 2000) {
                                            edges {
                                                node {
                                                    id
                                                }
                                            }
                                        }
                                    }
                                }`;

    let mutation = Relay.QL `mutation { createFlow }`;

    let save = types['flows'].defaultValues(organisation);

    save['flowDef_id'] = flowDef.realId;
    if (activate) {
        save['activated'] = true;
    }

    let saver = new EditorSaver(types['flows'], mutation, fatQuery, null, EditorSaver.CREATE);
    return saver.save(save).then((result) => {
        return Promise.resolve(result.createFlow.edge.node);
    });
}

class FlowAddStep1 extends React.Component {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'flows';

    static contextTypes = {
        router: PropTypes.object
    };

    _create = () => {
        let {flowDef} = this.props.user;

        if (!flowDef) {
            flowDef = this.props.user.flowDefs.edges[0].node;
        }

        if (!this.props.user.organisation) {
            return;
        }

        let promise;

        promise = createFlowFromFlowDef(flowDef, this.props.user.organisation);
        return promise.then((flow) => {
            let path = urlMapping.getUrl(types['flows'], "create-step-4", flow);
            this.context.router.push(path);
        });

    };

    render() {
        let {flowDef} = this.props.user;

        if (!flowDef) {
            flowDef = this.props.user.flowDefs.edges[0].node;
        }

        let type = types['flowDefs'];

        let longDescription = Tool.getDataForColumn('longDescription', type.fields(), flowDef);

        if (longDescription) {
            longDescription = Tool.tranformDataForView('flowDef', type.fields('longDescription'), this.props.intl.formatMessage, longDescription, false, 0);
        } else {
            longDescription = flowDef.description;
        }

        return (
            <AppPanel breadcrumbParams={[
                {type: types['flowDefs'], data: flowDef},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <h1>{flowDef.name}</h1>
                <p>{longDescription}</p>

                {BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_CHANNEL, this.props.user.organisation.realId)
                    ?
                        <button className="btn btn-primary" onClick={this._create}><FormattedMessage
                            defaultMessage="Start using " id="flow.startUsingFor"/>{" "}{flowDef.name}
                        </button>
                    :
                    <button className="btn btn-default" disabled><FormattedMessage defaultMessage="You don't have enough permission to create flow."
                                                                                   id="flow.permission.requires" /></button>
                }
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(FlowAddStep1), (props) => {
    return (props.user.flowDefs && props.user.flowDefs.edges.length > 0) || props.user.flowDef;
}), {
    initialVariables: {
        flowDefId: '',
        flowDefUrlFragment: '',
        flowDefIdSelected: false,
        flowDefUrlFragmentSelected: false,
        organisationId: '',
        organisationSelected: false,
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }
        variables['scenarioSelected'] = variables['scenarioId'] ? true : false;
        variables['organisationSelected'] = variables['organisationId'] ? true : false;
        variables['flowDefIdSelected'] = variables['flowDefId'] ? true : false;
        variables['flowDefUrlFragmentSelected'] = variables['flowDefUrlFragment'] ? true : false;
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                firstname,
                surname,
                email,
                organisation(id: $organisationId) @include(if: $organisationSelected) {
                    id,
                    realId,
                    name,
                    users(first: 2) {
                        edges {
                            node {
                                id,
                                realId
                            }
                        }
                    },
                },
                organisations(first: 20) {
                    edges {
                        node {
                            id,
                            realId,
                            name
                        }
                    }
                },
                flowDef(id: $flowDefId) @include(if: $flowDefIdSelected) {
                    id,
                    realId,
                    description,
                    name,
                    flowChannelDefs(first: 2000) {
                        edges {
                            node {
                                id,
                                key,
                                name,
                                channelDef_id,
                            }
                        }
                    }
                },
#                flowDefs(first: 1, urlFragment: $flowDefUrlFragment) @include(if: $flowDefUrlFragmentSelected) {
#                    edges {
#                        node {
#                            id,
#                            realId,
#                            description,
#                            name,
#                        }
#                    }
#                }
            }
        `,
    },
});
